import React, { useEffect, useState } from "react";

// A thin bar across the top of Poems and Stories while the signed-in account is looking at DEMO content (the dashboard's Demo button, or
// a seeded demo login). The gateway says whether it applies (GET /demo/view); for every other account it renders nothing. When the
// Demo button is what switched it on, the bar can switch it off again. The same file is used in both apps.
const CSS = `
.hvdemo-banner{position:fixed;top:0;left:0;right:0;z-index:2147483001;height:30px;display:flex;align-items:center;justify-content:center;gap:10px;
  background:#F5C755;color:#3B3000;font:700 12.5px/1 system-ui,-apple-system,Segoe UI,sans-serif;padding:0 10px;text-align:center;box-shadow:0 1px 6px rgba(0,0,0,.18)}
.hvdemo-banner button{border:0;background:#3B3000;color:#fff;font:inherit;font-weight:800;border-radius:999px;padding:5px 11px;cursor:pointer}
.hvdemo-banner button:disabled{opacity:.6}
body.has-demo-banner{padding-top:30px}
@media (max-width:520px){.hvdemo-banner{font-size:11px}}
`;

export default function DemoViewBanner({ gatewayUrl, getToken, what }) {
  const base = String(gatewayUrl || "").replace(/\/+$/, "");
  const [token, setTok] = useState(() => getToken());
  const [view, setView] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const id = setInterval(() => { const t = getToken(); setTok((p) => (p === t ? p : t)); }, 1500);
    return () => clearInterval(id);
  }, [getToken]);

  useEffect(() => {
    let alive = true;
    if (!token) { setView(null); return undefined; }
    fetch(`${base}/demo/view`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : { active: false }))
      .then((j) => alive && setView(j.active ? j : null))
      .catch(() => alive && setView(null));
    return () => { alive = false; };
  }, [base, token]);

  useEffect(() => {
    document.body.classList.toggle("has-demo-banner", !!view);
    return () => document.body.classList.remove("has-demo-banner");
  }, [view]);

  if (!view) return null;
  const turnOff = async () => {
    setBusy(true);
    try {
      await fetch(`${base}/account/demo-mode`, { method: "POST", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: JSON.stringify({ enabled: false }) });
      window.location.reload();
    } catch { setBusy(false); }
  };
  return (
    <div className="hvdemo-banner" role="status" data-testid="demo-view-banner">
      <style>{CSS}</style>
      <span>You are viewing demo content: {what} open, the rest are locked.</span>
      {view.source === "button" && <button type="button" onClick={turnOff} disabled={busy} data-testid="demo-view-off">{busy ? "..." : "Turn off demo"}</button>}
    </div>
  );
}
